import ClientType from '@/modules/common/enums/client-type.ts';

export const LEGAL_DATA_TYPES: ReadonlySet<number> = new Set([ClientType.Legal, ClientType.IP, ClientType.OwnLegal]);

export const LEGAL_ENTITY_TYPES: ReadonlySet<number> = new Set([ClientType.Legal, ClientType.OwnLegal]);
